import angular from 'angular';
import gettext from 'angular-gettext';
import Shepherd from "shepherd.js";
import localStorageService from 'angular-local-storage';

import './tutorial.scss';

export default angular.module('cms.page.tutorial', [gettext, localStorageService])
    .factory('tutorial', ($timeout, localStorageService, gettextCatalog, ClickOutside) => {

        let tutorialStorageKey = 'tutorial';

        let open = () => {

            let attachToElement = findSectionAttachTo();

            let tour = new Shepherd.Tour({
                defaults: {
                    classes: 'shepherd-theme-square-dark',
                    showCancelLink: false,
                    when: {
                        show: () => {
                            window.scrollTo(0, 0);
                        }
                    }
                }
            });

            let buttons = [
                {
                    text: gettextCatalog.getString('Exit'),
                    action: tour.cancel,
                    classes: 'shepherd-button-secondary'
                },
                {
                    text: gettextCatalog.getString('Back'),
                    action: tour.back,
                    classes: 'shepherd-button-secondary'
                },
                {
                    text: gettextCatalog.getString('Next'),
                    action: tour.next
                }

            ];
            tour.addStep('welcome', {
                title: gettextCatalog.getString('Welcome'),
                text: gettextCatalog.getString('Welcome to the <img style="max-width: 75px; display: inline-block;" src="/fonts/contente.svg" alt="logo"> trial. You can explore all builder functionalities without any limits. Just pick the first element and drag and drop it on the page to see how easy it is! Don\'t forget about registration to share your page with the wider audience.'),
                classes: 'shepherd shepherd-welcome',
                buttons: [buttons[0], buttons[2]],
                when: {
                    show: () => {
                        $timeout(() => {
                            $('.shepherd.shepherd-welcome.shepherd-has-title.shepherd-element').css('transform', 'translate(-230px,-90px)');
                        });
                    }
                }
            });

            tour.addStep('sectionLibrary', {
                title: gettextCatalog.getString('Toolbox modules'),
                text: gettextCatalog.getString('Click on the selected module with the left mouse button and drag and drop elements to the place where you want them in the workspace. Gray lines suggest where the item will be added.<img src="/images/drag_and_drop.gif" alt="drag and drop showcase" class="img-responsive"/>'),
                attachTo: '.section-library-tutorial top',
                buttons: buttons,
                when: {
                    'before-show': function () {
                        $(window).scrollTop(0);
                    }
                }
            });

            let columnsResizeStep = {
                title: gettextCatalog.getString('Resizing of columns'),
                text: gettextCatalog.getString('Drag (left or right) column divider to change columns size.<img src="/images/columns-resize.gif" alt="columns resize" class="img-responsive"/>'),
                when: {
                    'before-show': function() {
                        if (attachToElement) {
                            attachToElement.click();
                        }
                        $(window).scrollTop(0);
                    },
                    show: function() {
                        $timeout( () => {
                                $(window).scrollTop($(window).scrollTop()+5);
                                $(window).scrollTop($(window).scrollTop()-5);
                            }
                        )
                    }
                },
                buttons: buttons
            };

            if (attachToElement) {
                columnsResizeStep.attachTo ='.creator-workspace__section-selected top';
            }

            tour.addStep('columnsResize', columnsResizeStep);

            tour.addStep('editPageSettings', {
                title: gettextCatalog.getString('Editing page settings'),
                text: gettextCatalog.getString('You can manage information about your website here.'),
                attachTo: '.accordion-page-info left',
                when: {
                    'before-show': function () {
                        $(window).scrollTop(0);
                    },
                    show: function() {
                        $timeout( () => {
                                ClickOutside.clear();
                            }
                        )
                    }
                },
                buttons: buttons

            });

            let editPageModuleStep  = {
                title: gettextCatalog.getString('Module editions'),
                text: gettextCatalog.getString('You can edit and customize each element of the page here.'),
                attachTo: '.module-settings left',
                when: {
                    'before-show': function() {
                        if (attachToElement) {
                            attachToElement.click();
                        }
                        $(window).scrollTop(0);
                    },
                    show: function() {
                        $timeout(() => {
                            $(window).scrollTop($(window).scrollTop() + 15);
                            $(window).scrollTop($(window).scrollTop() - 15);
                        }, 300)

                    }
                },
                buttons: buttons

            };

            if (attachToElement) {
                editPageModuleStep.attachTo ='.module-settings left';
            }

            tour.addStep('editPageModule', editPageModuleStep);

            tour.addStep('mediaLibraryButton', {
                title: gettextCatalog.getString('Media library'),
                text: gettextCatalog.getString('Use media button to add beautiful images directly to your page. Choose from thousand Unsplash library photos or upload one of your own.<img src="/images/media-library.jpg" alt="stock photos" class="img-responsive"/>'),
                buttons: buttons,
                when: {
                    'before-show': function () {
                        $(window).scrollTop(0);
                    },
                    show: () => {
                        $timeout(() => {
                            $('div[data-id="mediaLibraryButton"]').css('transform', 'translate(-230px,-315px)');
                        });
                    }
                }
            });

            tour.addStep('menu', {
                title: gettextCatalog.getString('Adding menu'),
                text: gettextCatalog.getString('Drag and drop this component if you want to add the menu to your page.'),
                attachTo: '.creator-sections-element__section-pageMenu bottom',
                buttons: buttons,
                when: {
                    'before-show': function () {
                        $(window).scrollTop(0);
                    },
                }
            });

            let linkButtonStep = {
                title: gettextCatalog.getString('Adding menu item'),
                text: gettextCatalog.getString('Use this button to add a new element to your menu. Don\'t forget to add a section title.<img src="/images/section-title.jpg" alt="section title" class="img-responsive"/>'),
                when: {
                    'before-show': function () {
                        if (attachToElement) {
                            attachToElement.click();
                        }
                        $(window).scrollTop(0);
                        $timeout(() => {
                            if (attachToElement)
                                $(attachToElement).addClass('_shep-en-div');
                                $(window).scrollTop($(window).scrollTop()+5);
                                $(window).scrollTop($(window).scrollTop()-5);
                            }
                        )
                    },
                    hide: function () {
                        $timeout(() => {
                                $(attachToElement).removeClass('_shep-en-div');
                            }
                        )
                    }
                },
                buttons: buttons
            };

            if (attachToElement) {
                linkButtonStep.attachTo ='.creator-workspace__section-selected .btn-info top';
            }

            tour.addStep('linkButton', linkButtonStep);

            tour.addStep('remember', {
                title: gettextCatalog.getString('Do not forget about me'),
                text: gettextCatalog.getString('You can return to this tutorial anytime by clicking on the help icon in the upper right corner.'),
                attachTo: '.side-form top',
                buttons: [buttons[1],buttons[0]],
                when: {
                    'before-show': function () {
                        $(window).scrollTop(0);
                    }
                }

            });
            $timeout(function () {
                tour.start();
            })

        };

        let findSectionAttachTo = () => {
            let selectedElement = null;
            let pageSections = $('.section-pageSection');

            pageSections.each(function (index, element) {
                selectedElement = element;
                if (index === 2) {
                    selectedElement = element;
                    return false;
                }
            });

            return selectedElement;
        };

        let openIfFirstUsage = () => {
            let tutorial = localStorageService.get(tutorialStorageKey);
            if (tutorial) {
                return;
            }
            open();
            localStorageService.set(tutorialStorageKey, 1);
        };

        let clearFirstUsage = () => {
            localStorageService.remove(tutorialStorageKey);
        };

        return {
            open: open,
            openIfFirstUsage: openIfFirstUsage,
            clearFirstUsage: clearFirstUsage
        };

    }).name


// WEBPACK FOOTER //
// ./src/cmsPages/Pages/Tutorial/Tutorial.js